<template>
    <div id="replyTender">
        <my-header></my-header>
        <div class="banner">
            <img src="../../../assets/images/invitemanage/topBg.jpg"/>
            <div class="main-container">
                <div class="bannerText">
                    <h2>{{ projectName }}<span>询标回复</span></h2>
                    <p>{{ endTime ? '询标回复截止时间：'+endTime : '' }}</p>
                </div>
            </div>
        </div>
        <div class="main-container mainWrap">
            <div class="small-container titleWrap">
                <el-menu default-active="1" class="el-menu-demo" mode="horizontal">
                    <el-menu-item index="1">{{ sn }}</el-menu-item>
                </el-menu>
            </div>
            <section class="small-container">
                <h2>
                    <img src="../../../assets/images/invitemanage/tit01.png"/>
                    <!--<el-button type="primary"><i class="downloadIcon"></i>下载全部</el-button>-->
                </h2>
                <el-table
                    :data="inquiryList"
                    tooltip-effect="light"
                    style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="52">
                    </el-table-column>
                    <el-table-column
                        width="148"
                        :show-overflow-tooltip="true"
                        label="询标问卷">
                        <template slot-scope="scope">
                            <a class="words" href="javascript:;" @click="fileListHandleDownload(scope.row,2)" title="点击下载">
                                {{ scope.row.inquireAskFile ? scope.row.inquireAskFile.attachName : '' }}
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="148"
                        :show-overflow-tooltip="true"
                        prop="sendTime"
                        label="发出时间">
                    </el-table-column>
                    <el-table-column
                        width="148"
                        :show-overflow-tooltip="true"
                        prop="downloadTime"
                        label="下载时间">
                    </el-table-column>
                    <el-table-column
                        width="148"
                        prop="inquiryPriceTax"
                        label="询标报价（含税）">
                    </el-table-column>
                    <el-table-column
                        width="148"
                        prop="inquiryPriceNotax"
                        label="询标报价（不含税）">
                    </el-table-column>
                    <el-table-column
                        width="148"
                        :show-overflow-tooltip="true"
                        label="询标回复附件">
                        <template slot-scope="scope">
                            <a class="words" href="javascript:;" @click="fileListHandleDownload(scope.row,1)" title="点击下载">
                                {{ scope.row.answerFile ? scope.row.answerFile.attachName : '' }}
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        width="120">
                        <template slot-scope="scope">
                            <div>
                                <el-button
                                    :disabled="$route.params.entrance == 2"
                                    @click="openDialog(scope.row)"
                                    size="mini"
                                    style="padding:9px 18px;"><i class="el-icon-document" style="margin-right:3px;"></i>询标回复</el-button>
                            </div>
                            <!--<el-button v-else type="text">已回复</el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
                <p style="text-align:left;margin-top: 20px;"><span class="tips">提示：回复询标问卷，附件上传后必须提交，否则管理员无法看到回复的附件！</span></p>
            </section>
        </div>
        <el-dialog
            title="询标回复"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="dialogVisible">
            <el-form
                label-position="left"
                :model="replyForm"
                :rules="replyRules"
                status-icon
                ref="replyForm"
                label-width="160px"
                class="replyForm">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="报价（含税，元）：" prop="inquiryPriceTax">
                            <el-input v-model="replyForm.inquiryPriceTax" style="width: 220px;" size="small" :maxlength="20"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="报价（不含税，元）：" prop="inquiryPriceNotax" >
                            <el-input v-model="replyForm.inquiryPriceNotax" style="width: 220px;" size="small" :maxlength="20"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="计价方式：" required >
                            <span>{{ disPlayValorem }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="附件：" required class="uploadItem">
                            <page-upload :files="replyForm.sattachment "
                                         class="uploadFloat"
                                         v-on:finishUpload="finishUploadFile"
                                         :editFlag="true"
                                         attachmentType="94"
                                         :limitType="2"
                                         :isIconTable="2"
                                         :notMany="true"
                            ></page-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button  @click="submit">确 定</el-button>
              </span>
        </el-dialog>
    </div>
</template>
<script type="text/babel">
    import MyHeader from '../MasterHeader.vue';
    export default {
        name: 'replyTender',
        data() {
            var checkFile = function(rule,value,callback){
                if(value.length){
                    callback();
                } else {
                    callback(new Error('附件不能为空'))
                }
            };
            return {
                activeName: '0',//el-tab-pane的activeName
                projectName: '',//项目名称
                inquiryList: [],//询标问卷 回复
                fileList: [],
                inquiringBidTime: '',//询标截止时间
                disPlayValorem: '',//计价方式
                currentRow: '',//当前行
                isTime: true,//是否过了询标截止时间 true 未过期
                endTime: '',//截止时间
                sn:'',
                dialogVisible: false,//
                replyForm: {
                    inquiryPriceNotax: '',//不含税
                    inquiryPriceTax: '',//报价含税
                    sattachment : []//附件
                },
                replyRules:{
                    inquiryPriceNotax: [
                        { required: true, message: '报价不能为空',trigger: 'blur'},
                        { validator: this.checkDeg,trigger: 'blur' }
                    ],
                    inquiryPriceTax: [
                        { required: true, message: '报价不能为空',trigger: 'blur'},
                        { validator: this.checkDeg,trigger: 'blur' }
                    ],
                    sattachment : [
                        { required: true,validator: checkFile ,trigger:'change'}
                    ],
                }
            }
        },
        components: {MyHeader},
        created(){
            this.$root.activeIndex = 'win';
            this.getData();//初始化数据
        },
        methods: {
            getLabel(i){
                if (i == 0){
                    return '标段一';
                } else if(i == 1) {
                    return '标段二';
                } else if(i == 2) {
                    return '标段三';
                }
            },
            getData(){//获取数据
                this.$root.postHttp('/v1/outerformflow/inquiringBid/list',{
                    "formId": this.$route.params.formId,
                    "subId": this.$route.params.id
                }, (res) => {
                    this.inquiryList = res.data.data.inquiryList;
                    this.inquiringBidTime = res.data.data.inquiringBidTime;
                    this.projectName = res.data.data.dealBisVo.flowFormExtMng.formTitle;
                    this.sn = res.data.data.sn;
                    this.endTime = res.data.data.inquiringBidTime || '';
//                    this.disPlayValorem = res.data.data.disPlayValorem;//计价方式
                    if(res.data.data.disPlayValorem == '0'){
                        this.disPlayValorem = '一般计税';
                    } else if(res.data.data.disPlayValorem == '1'){
                        this.disPlayValorem = '简易征收';
                    } else if(res.data.data.disPlayValorem == '0,1'){
                        this.disPlayValorem = '一般计税，简易征收';
                    }else if(res.data.data.disPlayValorem == '1,0'){
                        this.disPlayValorem = '简易征收，一般计税';
                    }
                })
            },
            checkDeg(rule,value,callback){
                // let reg = /^(-?\d+)(\.\d+)?$/;
                let reg = /^\d+(\.\d{1,2})?$/;
                if(!reg.test(value)) {
                    callback(new Error('请输入数字，且小数点后不超过两位'));
                } else {
                    callback();
                }
            },
            openDialog(row){
//                console.log(777,row)
                this.currentRow = row;
                let arr = [];
                row.answerFile && arr.push(row.answerFile);
                this.replyForm.sattachment = [];
                this.replyForm = {
                    inquiryPriceNotax: row.inquiryPriceNotax || '',//不含税
                    inquiryPriceTax: row.inquiryPriceTax || '',//报价含税
                    sattachment : arr//附件
                };
                this.replyForm.sattachment = arr;
                this.dialogVisible = true;
            },
            cancel(){
                this.dialogVisible = false;
                this.replyForm.sattachment = [];
            },
           submit(){
               let that = this;
               that.$refs.replyForm.validate( valid => {
                   if(valid){
                       if(!that.replyForm.sattachment.length){
                           that.$alert('请上传附件！',{
                               type: 'warning'
                           });
                           return;
                       }
                       if(parseFloat(that.replyForm.inquiryPriceTax) <= parseFloat(that.replyForm.inquiryPriceNotax)){
                           that.$alert('含税报价须大于不含税报价，请重新填写！', '提示', {
                               confirmButtonText: '确定',
                               type: 'warning'
                           });
                           return;
                       }
                       that.$confirm('是否提交回复？',{
                           type:'warning',
                           confirmButtonText: '确定',
                           cancelButtonText: '取消'
                       }).then( (action) => {
//                           console.log(99,action,that.currentRow)
                           that.replyForm.formId = that.currentRow.inquireAskFile && that.currentRow.inquireAskFile.formId;
                           that.replyForm.id = that.currentRow.inquiryId;
                           that.replyForm.sattachment = that.replyForm.sattachment[0];
                           that.$root.postHttp('/v1/outerformflow/inquiringBid/submit',that.replyForm,function (res) {
                               that.$message.success('回复成功');
                               setTimeout( () => {
                                   that.dialogVisible = false
                                   that.getData();
                               },200)
                           },function () {
                               setTimeout( () => {
                                   that.dialogVisible = false;
                               },200)
                           });
                       }).catch((err) => {
//                           console.log('catch',err)
                           that.$message({
                               type: 'info',
                               message: '已取消回复'
                           })
                           that.dialogVisible = false;
                       });
                   } else {
                       that.$alert('请把带*的必填字段填写完整', '提示', {
                           confirmButtonText: '确定',
                           type: 'warning'
                       });
                   }
               })

           },
            finishUploadFile(val){//文件上传完成后，同步询标回复数据；
                // this.replyForm.sattachment = val.fileList;
                if(val.fileList.length){
                    if(this.replyForm.sattachment.length){
                        this.replyForm.sattachment[0].attachName = val.fileList[0].attachName;
                        this.replyForm.sattachment[0].attachPath = val.fileList[0].attachPath;
                        this.replyForm.sattachment[0].createByUsername = val.fileList[0].createByUsername;
                        this.replyForm.sattachment[0].attachSize = val.fileList[0].attachSize;
                    } else {
                        this.replyForm.sattachment[0]= {
                            attachName: val.fileList[0].attachName,
                            attachPath: val.fileList[0].attachPath,
                            createByUsername:val.fileList[0].createByUsername,
                            attachSize: val.fileList[0].attachSize
                        };
                    }
                }
            },
            fileListHandleDownload(val,type) {
                let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then( () => {
                    if(type == 1){
                        that.$root.downloadFile({
                            attachName: val.answerFile.attachName,
                            attachPath: val.answerFile.attachPath
                        });
                    }else {
                        that.$root.postHttp('/v1/outerformflow/bidFile/down',{
                            id: val.inquireAskFile.id,
                            formId: val.inquireAskFile.formId,
                            relatedId: val.inquireAskFile.relatedId,
                            type: val.inquireAskFile.attachmentType
                        },function (res) {
                            //code 1 成功了再进行下载
                            that.$root.downloadFile({
                                attachName: val.inquireAskFile.attachName,
                                attachPath: val.inquireAskFile.attachPath
                            });
                            that.getData();
                        });
                    }

                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消下载'
                    })
                });
            }
        }
    }
</script>
<style lang="scss">
@import "../../../assets/var";
#replyTender {
    padding: 80px 0 50px;
    min-height: 85vh;
    background: $--primary-fill-color;
    & .head-top{
        background: #fff;
    }
    & .head-right {
        color: $--text-color-light;
        & .login {
            background: url('../../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
        }
        & .register {
            background: url('../../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
        }
        & .line {
            background: $--text-color-light;
        }
        & .help {
            background: url('../../../assets/images/topBar2/icon05.png') no-repeat;
        }
        & .wechat {
            background: url('../../../assets/images/topBar2/icon06.png') no-repeat;
        }
    }
    .banner {
        img {
            width: 100%;
            min-width:1300px;
            height: 140px;
        }
        .main-container {
            position: relative;
            .bannerText {
                position: absolute;
                left: 0;
                top: -50px;
                width: 100%;
                color: #fff;
                line-height: 34px;
                h2 {
                    float: left;
                    font-size: 18px;
                    span {
                        display: inline-block;
                        vertical-align: middle;
                        border: 1px solid #fff;
                        padding: 0 8px;
                        margin-left: 15px;
                        height: 24px;
                        font-size: 14px;
                        line-height: 22px;
                        border-radius: 4px;
                        font-weight: normal;
                        box-sizing: border-box;
                    }
                }
                p {
                    float: right;
                    font-size: 14px;
                }
            }
        }
    }
    .mainWrap {
        position: relative;
        margin-top: 40px;
        padding-bottom: 60px;
        /*background: #fff;*/
    }
    .el-dialog {
        width: 70%;
        box-shadow: 0 0 5px #fff;
    }
    .el-dialog__header{
        text-align: left;
        background:$--secondary-fill-color;
    }
    .el-dialog__body {
        padding: 20px 30px;
    }
    .el-dialog__footer {
        text-align: center;
        margin-top: 15px;
    }
    .small-container {
        width: 1200px;
        box-sizing: border-box;
        margin: 0px auto;
        padding: 30px 50px 30px;
        background: #fff;
        h2 {
            /*margin-top: 50px;*/
            overflow: hidden;
            img {
                float: left;
                width: 282px;
                height: 30px;
            }
            .el-button {
                float: right;
                padding: 5px 25px;
                height: 30px;
                i {
                    display: inline-block;
                    margin-right: 8px;
                    width: 20px;
                    height: 20px;
                    vertical-align: middle;
                }
                .downloadIcon {
                    background: url('../../../assets/images/invitemanage/icon04.png') no-repeat;
                    background-position: 0 center;
                }
            }
        }
        .el-table{
            /*padding-top: 20px;*/
            th {
              text-align: center;
            }
            & .words {
                color: #333;
                text-decoration: none;
            }
            & .words:hover {
                color: $--primary-color;
                text-decoration: underline;
            }
        }
        & .tips {
            padding-left: 20px;
            font-weight: normal;
            font-size: 12px;
            color: $--primary-color;
            background: url('../../../assets/images/register/icon03.png') no-repeat left center;
        }
    }
    .replyForm {
        .el-form-item__label {
            padding: 0;
        }
        .el-form-item__content {
            text-align: left;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/master/inviteProcess/ReplyTender.vue